import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Image,
  Heading,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { modules, formats } from "../../utils/quillModules";
import * as mod from "../../url";
import { useNavigate } from "react-router-dom";

const CreateHomeBanner = () => {
  const [title, setTitle] = useState("");
  const [Des, setDes] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const toast = useToast();
  const navigate = useNavigate();
  const SIDEBAR_WIDTH = "250px";

  const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
  const token = storedData?.data?.token;
  const config = { headers: { Authorization: `${token}` } };

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!image) {
      toast({
        title: "Image is required",
        status: "error",
        duration: 3000,
      });
      return;
    }

    const formData = new FormData();
    formData.append("imgUrl", image);
    formData.append("title", title);
    formData.append("Des", Des);
    formData.append("linkUrl", linkUrl);

    try {
      setLoading(true);
      await axios.post(
        `${mod.api_url}/api/v1/newslatter/create/banner`,
        formData,
        config
      );

      toast({
        title: "Banner created successfully",
        status: "success",
        duration: 3000,
      });

      // Reset form
      setTitle("");
      setDes("");
      setLinkUrl("");
      setImage(null);
      setPreview(null);

      // Navigate to banner list page
      navigate("/home-banner");
    } catch (error) {
      console.error(error);
      toast({
        title: "Error creating banner",
        status: "error",
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="70px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={4}>
        <Heading size="md" mb={6} backgroundColor="blue.200" p={4}>
          Create Banner
        </Heading>

        <form onSubmit={handleSubmit}>
          <VStack spacing={4} align="stretch">
            <FormControl>
              <FormLabel>Title</FormLabel>
              <Input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter title"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Description</FormLabel>
              <ReactQuill
                value={Des}
                onChange={(value) => setDes(value)} // ✅ Fixed
                modules={modules}
                formats={formats}
                theme="snow"
                placeholder="Write description here..."
                style={{ height: "300px", marginBottom: "20px" }}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Link URL</FormLabel>
              <Input
                value={linkUrl}
                onChange={(e) => setLinkUrl(e.target.value)}
                placeholder="Enter link URL"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Image</FormLabel>
              <Input type="file" accept="image/*" onChange={handleFileChange} />
              {preview && (
                <Image
                  src={preview}
                  mt={2}
                  boxSize="150px"
                  objectFit="cover"
                  borderRadius="md"
                />
              )}
            </FormControl>

            <Button type="submit" colorScheme="blue" isLoading={loading}>
              Create Banner
            </Button>
          </VStack>
        </form>
      </Box>
    </>
  );
};

export default CreateHomeBanner;
